<template>
  <div class="hero">
    <v-container class="h-100">
      <div class="hero-content text-center">
        <h1 class="hero-title typography-display mb-8">
          {{ $t('hero.title.prefix') }}
          <span class="highlight">{{ $t('hero.title.highlight') }}</span>
          {{ $t('hero.title.suffix') }}
        </h1>
        <div class="features d-flex flex-column gap-4 mb-6 mx-auto">
          <div class="feature-item d-flex align-center justify-left typography-body-lg weight-medium">
            <v-icon color="primary" class="mr-4">mdi-check-circle</v-icon>
            <span>{{ $t('hero.features.forBuilders') }}</span>
          </div>
          <div class="feature-item d-flex align-center justify-left typography-body-lg weight-medium">
            <v-icon color="primary" class="mr-4">mdi-check-circle</v-icon>
            <span>{{ $t('hero.features.detailedEvaluation') }}</span>
          </div>
          <div class="feature-item d-flex align-center justify-left typography-body-lg weight-medium">
            <v-icon color="primary" class="mr-4">mdi-check-circle</v-icon>
            <span>{{ $t('hero.features.optimizationTips') }}</span>
          </div>
        </div>

        <!-- Credibility strip: verifiable reassurances (not invented usage
             metrics). Replace/extend with real testimonials or counts once
             those numbers exist. -->
        <ul class="hero-trust" aria-label="">
          <li>
            <v-icon size="18" aria-hidden="true">mdi-shield-check-outline</v-icon>
            <span>{{ $t('hero.trust.privacy') }}</span>
          </li>
          <li>
            <v-icon size="18" aria-hidden="true">mdi-view-grid-outline</v-icon>
            <span>{{ $t('hero.trust.depth') }}</span>
          </li>
          <li>
            <v-icon size="18" aria-hidden="true">mdi-timer-outline</v-icon>
            <span>{{ $t('hero.trust.speed') }}</span>
          </li>
          <li>
            <v-icon size="18" aria-hidden="true">mdi-account-hard-hat-outline</v-icon>
            <span>{{ $t('hero.trust.audience') }}</span>
          </li>
        </ul>
      </div>
    </v-container>
  </div>
</template>

<script setup>
</script>

<style scoped>
.hero {
  min-height: 21vh;
  background: var(--background);
  padding: 4rem 0 0 0;
}

.hero-content {  
  margin: 0 auto;
  max-width: 950px;
}

.hero-title {
  letter-spacing: 0;
  color: var(--text-primary);
  text-wrap: balance;
}

.feature-item {
  color: var(--text-secondary);
  gap: 0.75rem;
}

.feature-item .v-icon {
  color: var(--primary) !important;
}

.highlight {
  color: var(--v-primary-base);
  font-weight: var(--font-weight-bold);
}

.hero-trust {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 18px;
  margin: 0 auto;
  padding: 0;
  max-width: 760px;
  list-style: none;
}

.hero-trust li {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary);
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-medium);
}

.hero-trust .v-icon {
  color: var(--primary) !important;
}

/* On mobile the upload card must stay near the first viewport (conversion
   priority), so the credibility strip is desktop/tablet only. */
@media (max-width: 600px) {
  .hero-trust {
    display: none;
  }
}

.features {
  max-width: 450px;
}

@media (max-width: 600px) {
  .hero {
    padding: 0.75rem 0 0 0;
    min-height: auto;
  }

  .hero-content {
    max-width: 300px;
  }

  .hero-title {
    font-size: clamp(2.3rem, 10vw, 3.2rem) !important;
    line-height: 0.98 !important;
    letter-spacing: 0;
    margin-bottom: 1rem !important;
  }
  
  .features {
    max-width: 280px;
    padding: 0;
    margin-bottom: 0.75rem !important;
    gap: 0.625rem !important;
  }

  .feature-item {
    justify-content: flex-start;
    text-align: left;
    font-size: calc(var(--font-size-body-2) + 0.0625rem);
    line-height: 1.15;
    gap: 0.5rem;
  }

  .feature-item .v-icon {
    margin-right: 0 !important;
    font-size: 1.25rem;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .hero-title {
    letter-spacing: 0;
  }
}
</style>
